import type { FC } from 'react';

import ActivityFeedCard from '@/features/dashboard/components/ActivityFeedCard';
import CampusActivityCard from '@/features/dashboard/components/CampusActivityCard';
import DashboardMetrics from '@/features/dashboard/components/DashboardMetrics';
import OperationsQueueCard from '@/features/dashboard/components/OperationsQueueCard';
import RevenueGrowthCard from '@/features/dashboard/components/RevenueGrowthCard';
import { TIMESERIES_DAYS } from '@/features/dashboard/constants';
import { useDashboardPage } from '@/features/dashboard/hooks/useDashboardPage.hook';

const DashboardPage: FC = () => {
  const vm = useDashboardPage();

  return (
    <div className="flex flex-col gap-6">
      <header>
        <h1 className="text-[22px] font-extrabold tracking-tight text-[var(--color-ink)]">
          {vm.greetingName} 👋
        </h1>
        <p className="mt-1 text-[13px] text-[var(--color-ink-muted)]">
          Here&rsquo;s what&rsquo;s happening on Shoutt today · {vm.today}
        </p>
      </header>

      {vm.isLoading ? (
        <div className="rounded-2xl border border-[var(--color-divider)] bg-white p-10 text-center text-[13px] text-[var(--color-ink-muted)] shadow-[var(--shadow-card)]">
          Loading dashboard…
        </div>
      ) : vm.isError || !vm.overview ? (
        <div className="rounded-2xl border border-[var(--color-divider)] bg-white p-10 text-center shadow-[var(--shadow-card)]">
          <p className="text-[14px] font-semibold text-[var(--color-ink)]">
            Couldn&rsquo;t load the dashboard
          </p>
          <p className="mt-1 text-[13px] text-[var(--color-ink-muted)]">
            {vm.errorMessage ?? 'Please try again.'}
          </p>
        </div>
      ) : (
        <>
          <DashboardMetrics
            overview={vm.overview}
            onOpenOnboardingQueue={vm.onOpenOnboardingQueue}
            onOpenReports={vm.onOpenReports}
          />

          <div className="grid grid-cols-1 gap-4 xl:grid-cols-[1fr_340px]">
            <RevenueGrowthCard
              points={vm.timeseries}
              revenueMtdPaise={vm.overview.revenueMtdPaise.value}
              days={TIMESERIES_DAYS}
            />
            <CampusActivityCard items={vm.campusActivity} />
          </div>

          <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
            <OperationsQueueCard
              queue={vm.overview.operations}
              onOpenPayments={vm.onOpenPayments}
              onOpenReports={vm.onOpenReports}
            />
            <ActivityFeedCard items={vm.activity} />
          </div>
        </>
      )}
    </div>
  );
};

export default DashboardPage;
